/* Leap Years landing page (template product.lp-nad).
   Part 1: agency behaviour (sliders, accordions, sticky header, scroll to buy box).
   Part 2: buy box wired to the real product variants and Recharge selling plans. */

(function () {
  'use strict';

  /* ---------- Delivery date: N business days from today ---------- */
  function deliveryDate() {
    var host = document.querySelector('[data-lp-ship-days]');
    var days = host ? parseInt(host.getAttribute('data-lp-ship-days'), 10) || 4 : 4;
    var d = new Date();
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    var dn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var mn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var txt = dn[d.getDay()] + ', ' + mn[d.getMonth()] + ' ' + d.getDate();
    document.querySelectorAll('[data-lp-delivery]').forEach(function (el) { el.textContent = txt; });
  }

  /* ---------- Agency behaviour ---------- */
  function agency() {
    var $ = window.jQuery;
    if (!$ || !window.Swiper) return;

    if (document.querySelector('.mainSwiper')) {
      // Show every thumbnail at once (up to 6), so all slides are visible
      var thumbCount = document.querySelectorAll('.thumbSwiper .swiper-slide').length || 4;
      var thumbSwiper = new Swiper('.thumbSwiper', {
        spaceBetween: 10, slidesPerView: Math.min(Math.max(thumbCount, 1), 6), freeMode: true, watchSlidesProgress: true,
        breakpoints: { 0: { spaceBetween: 3 }, 768: { spaceBetween: 5 }, 1023: { spaceBetween: 10 } }
      });
      new Swiper('.mainSwiper', {
        spaceBetween: 10, loop: true, speed: 600,
        thumbs: { swiper: thumbSwiper },
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
      });
    }

    $(document).on('click', '.btn_scorall', function (e) {
      var target = $('#packg');
      if (!target.length) return;
      e.preventDefault();
      $('html, body').animate({ scrollTop: target.offset().top - 60 }, 1200);
    });

    function accordion(headSel, bodySel, openCls) {
      $(document).on('click', headSel, function () {
        var q = $(this);
        var a = q.next(bodySel);
        var idx = $(bodySel).index(a);
        $(bodySel).each(function (i, el) {
          if (i !== idx && $(el).is(':visible')) {
            $(el).slideUp(500, function () { $(el).prev(headSel).removeClass(openCls); });
          }
        });
        if (a.is(':visible')) {
          a.stop().slideUp(500, function () { q.removeClass(openCls); });
        } else {
          q.addClass(openCls);
          a.stop().slideDown(500);
        }
      });
    }
    accordion('.banner__accordion', '.banner__acdn-content', 'banner__accordion-open');
    accordion('.accordion', '.acdn-content', 'accordion-open');

    $(document).on('scroll', function () {
      $('.top_fix_bar').toggleClass('fixed-nav', $(this).scrollTop() > 40);
    });

    testimonials();
  }

  function testimonials() {
    var thumbWrapper = document.querySelector('.testithumbSwiper .swiper-wrapper');
    if (!thumbWrapper || !document.querySelector('.testiSwiper')) return;
    var originals = Array.from(thumbWrapper.children);
    var ORIG = originals.length;
    for (var c = 0; c < 2; c++) {
      originals.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev', 'swiper-slide-visible', 'swiper-slide-thumb-active');
        clone.removeAttribute('data-swiper-slide-index');
        thumbWrapper.appendChild(clone);
      });
    }
    var thumb = new Swiper('.testithumbSwiper', {
      slidesPerView: 3, spaceBetween: 10, centeredSlides: true, loop: true, loopAdditionalSlides: 9,
      watchSlidesProgress: true, slideToClickedSlide: true, allowTouchMove: true, speed: 500,
      breakpoints: {
        0: { slidesPerView: 1.3, spaceBetween: 15, loopAdditionalSlides: 6 },
        768: { slidesPerView: 3, spaceBetween: 35, loopAdditionalSlides: 9 },
        1023: { slidesPerView: 3, spaceBetween: 45, loopAdditionalSlides: 9 }
      }
    });
    var main = new Swiper('.testiSwiper', {
      slidesPerView: 1, spaceBetween: 10, loop: true, loopAdditionalSlides: 9, speed: 500,
      navigation: { nextEl: '.testi-button-next', prevEl: '.testi-button-prev' }
    });
    function norm(i) { return ((i % ORIG) + ORIG) % ORIG; }
    function highlight(o) {
      document.querySelectorAll('.testithumbSwiper .swiper-slide').forEach(function (el) {
        el.classList.remove('swiper-slide-thumb-active');
        var i = el.getAttribute('data-swiper-slide-index');
        if (i !== null && norm(parseInt(i, 10)) === o) el.classList.add('swiper-slide-thumb-active');
      });
    }
    function closest(o) {
      var cur = thumb.realIndex, total = ORIG * 3, best = null, bestD = Infinity;
      for (var i = 0; i < total; i++) {
        if (norm(i) !== o) continue;
        var raw = Math.abs(i - cur), d = Math.min(raw, total - raw);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }
    main.on('slideChange', function () {
      var o = norm(this.realIndex); highlight(o);
      var t = closest(o);
      if (t !== null && t !== thumb.realIndex) thumb.slideToLoop(t, 500);
    });
    thumb.on('slideChange', function () {
      var o = norm(this.realIndex); highlight(o);
      if (main.realIndex !== o) main.slideToLoop(o, 500);
    });
    thumb.on('click', function (s) {
      var c = s.clickedSlide; if (!c) return;
      var i = c.getAttribute('data-swiper-slide-index'); if (i === null) return;
      var o = norm(parseInt(i, 10)); highlight(o);
      if (main.realIndex !== o) main.slideToLoop(o, 500);
    });
    requestAnimationFrame(function () {
      var o = norm(main.realIndex); highlight(o);
      var t = closest(o); if (t !== null) thumb.slideToLoop(t, 0);
    });
  }

  /* ---------- Buy box ---------- */
  function monthsFromText(txt) {
    if (!txt) return null;
    var m = String(txt).match(/(\d+)\s*-?\s*(day|week|month|year)/i);
    if (!m) return null;
    var n = parseInt(m[1], 10), u = m[2].toLowerCase();
    if (u === 'month') return n;
    if (u === 'year') return n * 12;
    if (u === 'week') return Math.round(n / 4.345);
    return Math.round(n / 30);
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100);
    var fmt = format || '${{amount}}';
    var withDelims = function (num, dec, thou, decSep) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(amount, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(amount, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(amount, 0, '.', ',');
        default: return withDelims(amount, 2, ',', '.');
      }
    });
  }

  function BuyBox(root) {
    this.root = root;
    this.product = JSON.parse(root.querySelector('[data-lp-product]').textContent);
    this.moneyFormat = root.getAttribute('data-money-format');
    this.matchInterval = root.getAttribute('data-match-interval') !== 'false';
    this.afterAdd = root.getAttribute('data-after-add') || 'checkout';
    this.savingsBasis = root.getAttribute('data-savings-basis') || 'monthly';
    var names = (this.product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var sizeName = root.getAttribute('data-size-option') || 'Dog Size';
    this.sizeIdx = names.indexOf(sizeName);
    if (this.sizeIdx < 0) this.sizeIdx = 0;
    this.supplyIdx = names.length > 1 ? (this.sizeIdx === 0 ? 1 : 0) : -1;
    this.plans = {};
    var self = this;
    (this.product.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) { self.plans[p.id] = p; });
    });
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-lp-card]'));
    this.tiles = Array.prototype.slice.call(root.querySelectorAll('.pet_size_col'));
    this.button = root.querySelector('[data-lp-add]');
    this.buttonLabel = root.querySelector('[data-lp-add-label]');
    this.buttonText = this.buttonLabel ? this.buttonLabel.textContent : '';
    this.error = root.querySelector('[data-lp-error]');

    var params = new URLSearchParams(window.location.search);
    this.size = params.get('size') || root.getAttribute('data-default-size');
    this.selected = params.get('plan') || root.getAttribute('data-default-card') || '1';
    this.bind();
    this.hideMissingSizes();
    this.setSize(this.size);
  }

  BuyBox.prototype.opt = function (v, idx) { return idx < 0 ? null : v['option' + (idx + 1)]; };
  BuyBox.prototype.norm = function (s) { return String(s || '').trim().toLowerCase(); };

  BuyBox.prototype.variantsFor = function (size) {
    var self = this;
    return this.product.variants.filter(function (v) { return self.norm(self.opt(v, self.sizeIdx)) === self.norm(size); });
  };

  BuyBox.prototype.supplyMonths = function (v) {
    return monthsFromText(this.opt(v, this.supplyIdx)) || 1;
  };

  BuyBox.prototype.planMonths = function (plan) {
    if (!plan) return null;
    var found = null;
    (plan.options || []).forEach(function (o) { if (found === null) found = monthsFromText(o.value); });
    return found !== null ? found : monthsFromText(plan.name);
  };

  BuyBox.prototype.resolve = function (card, size) {
    var self = this;
    var vs = this.variantsFor(size);
    if (!vs.length) return null;
    var smallest = vs.slice().sort(function (a, b) { return self.supplyMonths(a) - self.supplyMonths(b); })[0];
    var want = card.getAttribute('data-supply');
    var v = want ? vs.find(function (x) { return self.norm(self.opt(x, self.supplyIdx)) === self.norm(want); }) : smallest;
    if (!v) return null;
    var months = this.supplyMonths(v);
    var baseMonthly = smallest.price / this.supplyMonths(smallest);
    var type = card.getAttribute('data-type');

    if (type === 'onetime') {
      var refOt = Math.max(v.compare_at_price || 0, this.savingsBasis === 'same_variant' ? 0 : Math.round(baseMonthly * months));
      return { variant: v, plan: null, months: months, price: v.price, compare: refOt > v.price ? refOt : null };
    }

    var allocs = v.selling_plan_allocations || [];
    var alloc = null;
    if (this.matchInterval) {
      alloc = allocs.find(function (a) { return self.planMonths(self.plans[a.selling_plan_id]) === months; }) || null;
    } else {
      alloc = allocs[0] || null;
    }
    if (!alloc) return null;
    var ref = this.savingsBasis === 'same_variant' ? v.price : Math.max(v.price, Math.round(baseMonthly * months));
    return { variant: v, plan: alloc.selling_plan_id, months: months, price: alloc.price, compare: ref > alloc.price ? ref : null };
  };

  BuyBox.prototype.setField = function (card, f, val) {
    var el = card.querySelector('[data-f="' + f + '"]');
    if (!el) return;
    if (val) { el.textContent = val; el.style.display = ''; } else { el.textContent = ''; el.style.display = 'none'; }
  };

  BuyBox.prototype.hideMissingSizes = function () {
    var self = this;
    this.tiles.forEach(function (t) {
      if (!self.variantsFor(t.getAttribute('data-size')).length) t.classList.add('lp-hidden');
    });
  };

  BuyBox.prototype.setSize = function (size) {
    var self = this;
    if (!this.variantsFor(size).length) {
      var firstTile = this.tiles.find(function (t) { return !t.classList.contains('lp-hidden'); });
      if (!firstTile) return;
      size = firstTile.getAttribute('data-size');
    }
    this.size = size;
    this.tiles.forEach(function (t) {
      var on = self.norm(t.getAttribute('data-size')) === self.norm(size);
      t.classList.toggle('active', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var label = this.root.querySelector('[data-lp-size-label]');
    if (label) label.textContent = size;

    var seen = {};
    this.resolved = {};
    this.cards.forEach(function (card) {
      var id = card.getAttribute('data-lp-card');
      var r = self.resolve(card, size);
      var key = r ? r.variant.id + ':' + (r.plan || 'ot') : null;
      if (!r || seen[key]) {
        card.classList.add('lp-hidden');
        return;
      }
      seen[key] = true;
      self.resolved[id] = r;
      card.classList.remove('lp-hidden');
      card.classList.toggle('lp-soldout', !r.variant.available);
      self.setField(card, 'note', card.getAttribute('data-note') || '');
      if (card.querySelector('[data-f="label"]')) {
        self.setField(card, 'label', r.months + '-Month Supply');
        self.setField(card, 'compare', r.compare ? formatMoney(r.compare, self.moneyFormat) : '');
        self.setField(card, 'price', formatMoney(r.price, self.moneyFormat));
        self.setField(card, 'permonth', r.months > 1 ? formatMoney(Math.round(r.price / r.months), self.moneyFormat) + ' per month' : '');
        var pct = r.compare ? Math.round((1 - r.price / r.compare) * 100) : 0;
        self.setField(card, 'save', pct >= 1 ? 'You Save ' + pct + '%' : '');
      } else {
        self.setField(card, 'price', formatMoney(r.price, self.moneyFormat));
      }
    });

    // Keep subscription cards the same height when only one of them shows a per-month line
    var pm = this.cards.filter(function (c) { return !c.classList.contains('lp-hidden'); })
      .map(function (c) { return c.querySelector('[data-f="permonth"]'); }).filter(Boolean);
    if (pm.some(function (el) { return el.textContent; })) {
      pm.forEach(function (el) { if (!el.textContent) { el.textContent = '\u00a0'; el.style.display = ''; } });
    }

    if (!this.resolved[this.selected]) {
      var def = this.root.getAttribute('data-default-card');
      this.selected = this.resolved[def] ? def : Object.keys(this.resolved)[0];
    }
    this.select(this.selected);
  };

  BuyBox.prototype.select = function (id) {
    this.selected = id;
    this.cards.forEach(function (c) { c.classList.toggle('active', c.getAttribute('data-lp-card') === id); });
    var r = this.resolved[id];
    this.showError('');
    if (!r) { this.button.disabled = true; return; }
    var sold = !r.variant.available;
    this.button.disabled = sold;
    if (this.buttonLabel) this.buttonLabel.textContent = sold ? 'Sold Out' : this.buttonText;
  };

  BuyBox.prototype.showError = function (msg) {
    if (!this.error) return;
    this.error.textContent = msg;
    this.error.hidden = !msg;
  };

  BuyBox.prototype.bind = function () {
    var self = this;
    function onActivate(el, fn) {
      el.addEventListener('click', fn);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(); }
      });
    }
    this.tiles.forEach(function (t) { onActivate(t, function () { self.setSize(t.getAttribute('data-size')); }); });
    this.cards.forEach(function (c) { onActivate(c, function () { self.select(c.getAttribute('data-lp-card')); }); });
    this.button.addEventListener('click', function () { self.add(); });
  };

  BuyBox.prototype.add = function () {
    var self = this;
    var r = this.resolved[this.selected];
    if (!r || this.busy) return;
    this.busy = true;
    this.button.classList.add('lp-loading');
    this.showError('');
    var item = { id: r.variant.id, quantity: 1 };
    if (r.plan) item.selling_plan = r.plan;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, body: j }; }); })
      .then(function (out) {
        if (!out.ok) throw new Error(out.body.description || out.body.message || 'Could not add to cart.');
        if (self.afterAdd === 'cart') { window.location.href = root + 'cart'; return; }
        // Same route as the theme's own checkout button: POST /cart with "checkout"
        var f = document.createElement('form');
        f.method = 'post';
        f.action = root + 'cart';
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = 'checkout'; i.value = '';
        f.appendChild(i);
        document.body.appendChild(f);
        f.submit();
      })
      .catch(function (err) {
        self.busy = false;
        self.button.classList.remove('lp-loading');
        self.showError(err.message || 'Something went wrong. Please try again.');
      });
  };

  function init() {
    deliveryDate();
    agency();
    document.querySelectorAll('[data-lp-buybox]').forEach(function (el) {
      try { el._lp = new BuyBox(el); } catch (e) { console.error('[LP buy box]', e); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
